import { useMobileDetect } from "hooks/useMobileDetect";
import { Outlet } from "react-router-dom";

const SessionLayout = () => {
    const mobile = useMobileDetect();
  
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default SessionLayout;
